import React from 'react';

import styles from './troy.module.scss';

import { ChoiceForm, Translation } from '../../components/common';
import { connectTo } from '../../utils';
import { getQuestions, sendAnswers } from '../../actions/questions';
import { FEEDBACK, THANKS } from '../../constants/routes';

const buttonKey = 'MESSAGE_TO_AGENCY_BUTTON';
const mainKey = 'MESSAGE_TO_AGENCY_MAIN';
const mainHeaderKey = 'MESSAGE_TO_AGENCY_MAIN_HEADER';
const topKey = 'MESSAGE_TO_AGENCY_TOP';
const topHeaderKey = 'MESSAGE_TO_AGENCY_TOP_HEADER';

class MessageToAgency extends React.Component {
  componentDidMount() {
    const { getQuestions, questions, language } = this.props;
    if (!questions && language) {
      getQuestions();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { getQuestions, language } = this.props;
    if (language !== prevProps.language) {
      getQuestions();
    }
  }

  onSubmit = (values) => {
    const { questions, sendAnswers, history, showFeedback } = this.props;
    sendAnswers({
      answers: questions
        ? questions.map(({ group, id }) => ({
            group,
            id,
            value: !!values[id],
          }))
        : null,
    });
    history.push(showFeedback ? FEEDBACK : THANKS);
  };

  render() {
    const { translations, questions } = this.props;
    return (
      <div className={styles['message-to-agency__wrapper']}>
        <div className={styles['message-to-agency__head']}>
          <h2 className={styles['message-to-agency__head-header']}>
            <Translation>{topHeaderKey}</Translation>
          </h2>
          <div className={styles['message-to-agency__head-content']}>
            <Translation>{topKey}</Translation>
          </div>
          <div className={styles['message-to-agency__main-content']}>
            <h2 className={styles['message-to-agency__head-header']}>
              <Translation>{mainHeaderKey}</Translation>
            </h2>
            <div className={styles['message-to-agency__head-content']}>
              <Translation>{mainKey}</Translation>
            </div>
          </div>
          <ChoiceForm
            {...{ styles, questions }}
            onSubmit={this.onSubmit}
            pageName="message-to-agency"
            button={(translations && translations[buttonKey]) || ''}
          />
        </div>
      </div>
    );
  }
}

export default connectTo(
  ({
    translations: { translations, language },
    questions: { toAgency },
    payment: {
      show: { feedback },
    },
  }) => ({
    translations,
    language,
    questions: toAgency,
    showFeedback: feedback,
  }),
  { getQuestions, sendAnswers },
  MessageToAgency
);
